var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEye(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.09683 11.5534C4.88981 9.77258 7.14475 6 12 6C16.8553 6 19.11 9.77274 19.9028 11.5535C20.0306 11.8405 20.0306 12.1595 19.9028 12.4465C19.11 14.2273 16.8553 18 12 18C7.14475 18 4.88981 14.2274 4.09683 12.4466C3.96902 12.1595 3.96902 11.8405 4.09683 11.5534ZM12 4C5.89123 4 3.13911 8.78756 2.26978 10.7399C1.91138 11.5448 1.91138 12.4552 2.26978 13.2601C3.13911 15.2124 5.89123 20 12 20C18.1089 20 20.8608 15.2122 21.7299 13.2599C22.0882 12.4552 22.0882 11.5448 21.7299 10.7401C20.8608 8.78782 18.1089 4 12 4ZM8 12C8 9.79086 9.79086 8 12 8C14.2091 8 16 9.79086 16 12C16 14.2091 14.2091 16 12 16C9.79086 16 8 14.2091 8 12ZM12 10C11.9716 10 11.9434 10.0006 11.9153 10.0018C11.9701 10.1577 12 10.3253 12 10.5C12 11.3284 11.3284 12 10.5 12C10.3253 12 10.1577 11.9701 10.0018 11.9153C10.0006 11.9434 10 11.9716 10 12C10 13.1046 10.8954 14 12 14C13.1046 14 14 13.1046 14 12C14 10.8954 13.1046 10 12 10Z",
    fill: "#202020"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEye);
export default __webpack_public_path__ + "static/media/eye.676d3336c908289bbd2d1f0f0e79c479.svg";
export { ForwardRef as ReactComponent };